export interface I_Group {
    ProductType: string; // 1:主題旅遊 2:國外團體 3:台灣團體 4:團體自由行(不分國內外)
    IsB2E: boolean; // Session.agnt_agent 為空值=false
    CreditCardUrl: string; // 刷卡好康url
    CruiseRoomUrl: string; // 看艙房url
    GoAirline: string; // 去程航空公司
    GoDepartureTime: string; // 去程出發時間
    GoArriveTime: string; // 去程到達時間
    GoDepartureAirport: string; // 去程出發機場
    GoArriveAirport: string; // 去程到達機場
    GoTransferCount: number; // 去程總計
    BackAirline: string; // 回程航空公司
    BackDepartureTime: string; // 回程出發時間
    BackArriveTime: string; // 回程出到達時間
    BackDepartureAirport: string; // 回程出發機場
    BackArriveAirport: string; // 回程到達機場
    BackTransferCount: number; // 回程總計
    TourIndex: number; // 行程幾
    CheckCruiseInfo: boolean; // 是否是郵輪
    TelType: number; // 類型 (0：全部、1：國外團體旅遊、2：台灣旅遊、3：主題旅遊)
    IsNoFlight: boolean; // 是否有航空
    IsPreview: boolean; // 是否為後台預覽模式
    IsEnsureGroup: boolean; //是否已勾選顯示成團
    GroupInfo: {
        // 單團資訊
        TourID: string; // 行程代碼
        TourName: string; // 行程名稱
        NormGroupID: string; // 標準團名ID
        NormGroup: string; // 標準團名名稱
        NormGroupImg: string; // 標準團圖片 EXAPI PD93 增加回傳標準團名圖片
        TourDays: number; // 行程天數
        GoDate: string; // 出發日期
        BackDate: string; // 回程日期
        IsSleepless: boolean; // 是否夜未眠
        Status: number; //產品開團狀態：
        /*
            1：報名
            2：候補
            3：額滿
            4：請洽專員
            5：關團(包含結團、鎖團、已截止)
            6：近期上架
            7：取消(僅測試機)
        */
        StatusUrl: string; // 報名按鈕連結
        TotalSeats: number; // 總團位數
        QuotaSeats: number; // 可賣位數
        SpareSeats: number; // 可後補位數
        IsBooked: boolean; // 是否為預定
        IsEnsureGroup: boolean; // 是否為保證出團
        IsForeign: boolean; // 是否為國外(true)、國內(false)
        TravelType: number; // 旅遊型態(1:團體、2:團體自由行)
        ThemeID: string[]; // 主題旅遊代碼
        AgeCalculation: string; // 年齡基準日
        StraightLowestPrice: number; // 大人最低直售價
        IndustryLowestPrice: number; // 大人最低批售價(會員限購最低價不納入比較)
        EnterLowestprise: number; // 大人最低企業價(會員限購最低價不納入比較)
        IsVip: boolean; // 是否有會員限購價
        VipOrigPrice: number; // 會員限購價最低價
        ArriveID: string; // 目的地代碼(目的地-副線別-線別)
        MutiGroup: boolean; // 是否有多團
        TourBu: string; // 團控集團
        TourBuName: string; // 聯營商品公司名稱(原_TravelInfo.cshtml顯示邏輯)
        KKSeats: number; // 有位有繳訂金
        RegisteredSeats: number; // 已報名
        KeepSeats: number; // 保留位數
        OBSeats: number; // 候補有繳訂金位數
        GroupID: string; // 團號(後面加「-開團公司」)
        ActualSeats: number; // 實際人數(含領隊)
        WaitSeats: number; // 候補人數
        LevelID: number; //標準團名等級代碼
        /*
            NULL：一般、
            1：經典、2：特選、3：尊爵、4：旗艦、
            5：主題、6：創新、7：客製、8：璽品
        */
        TagList: I_Tag[]; // 標籤清單
        TripTypeList: I_TripType[]; // 旅遊型態 EXAPI PD93 增加回傳TripTypeList
        CurrencyCode: string; // 幣別資訊
        Price: string; // 售價(原_TravelInfo.cshtml判斷顯示售價邏輯)
        OrigPrice: string; // 原價(原_TravelInfo.cshtml判斷顯示原價邏輯)
        StartFromCityList: I_StartFromCity[]; // 出發城市 EXAPI PD93 增加回傳StartFromCityList
    };
    CalendarGroups: {
        isListMode: boolean;
        isLoadingCalendar: boolean; //detail頁面, 月曆(Calendar)api的讀取狀態
        isGuaranteedDisabled: boolean;
        isGuaranteedChecked: boolean;
        parmIsEnsureGroup: boolean;
        month: string;
        groups: I_CalendarGroup[];
    };
    todayMore: {
        NormGroupID?: string;
        GroupList: I_TodayMoreGroup[];
    };
    Schedules?: I_GroupAllSchedules;
    PricesInfo?: I_PricesInfo;
    StationInfoList: I_StationInfoList[];
    // Ski?: I_Ski;
    FlightInfo?: {
        GroupList: I_TodayMoreGroup[];
    };
    isHeaderShow: boolean; // 產品頁nav是否有出現
    currentTourID: string;
    callJson: I_CallJson;
    scheduleActive: number;
    isLoading: boolean; // 是否載入中
    isSearchPanelFixed: boolean; //m版搜尋面板是否fixed
}

export interface I_Tag {
    TagName: string;
    TagSort: number;
    TagNo: number;
}

export interface I_TripType {
    Name: string;
    Code: string;
}

export interface I_StartFromCity {
    CityName: string;
    CityCode: string;
}
export interface I_CalendarGroup {
    TourID: string;
    NormGroupID: string;
    ScheduleType: string;
    ID: string;
    Guaranteed: boolean;
    Date: string;
    WeekDay: string;
    CreditCard: boolean;
    Price: string;
    AvailableVacancy: number;
    TotalVacnacy: number;
    Status: string;
    Href: string;
    TourPrice: string;
    IsVip: boolean;
    VipOrigPrice: number;
    CurrencyCode: string;
}

export enum ProductTypes {
    ThemeTravel = '1',
    ForeignGroup = '2',
    TaiwanGroup = '3',
    GroupFree = '4',
}

export interface I_GroupAllModeswitcher {}

// 團費說明
export interface I_PricesInfo {
    GroupID: string; // 團號(後面加「-開團公司」)
    GoDate: string; // 出發日期
    BackDate: string; // 回程日期
    TourDays: number; // 行程天數
    TourName: string; // 行程名稱
    TravelType: TravelTypes; // 旅遊型態 (1:團體、2:團體自由行)
    IsCutPrice: boolean; // 是否直客可降價
    IsFullPay: boolean; // 是否需全額付清
    IsImmediatePay: boolean; // 是否須立即付款
    IsBabySeat: boolean; // 嬰兒是否佔位
    OrderPrice: number; // 單人訂金
    IsVip: boolean; // 是否有會員限購價
    VipOrigPrice: number; // 會員限購價最低價
    VisaPriceContain: I_CostInfo; // 簽證費(包)
    VisaPrice: I_CostInfo; // 簽證費(不包)
    AirportPriceContain: I_CostInfo; // 機場稅(包)
    AirportPrice: I_CostInfo; // 機場稅(不包)
    Meals: Array<I_Meal>; // 餐費
    StraightRemarks: string; // 直客備註
    IndustryRemards: string; // 批售備註
    PriceList: Array<I_PriceReOrg>; // 顯示參團費 & 房價
    IsB2E: boolean;
    IsEmptyRemarks: boolean; // 備註是否有資料
    IsDataNull: boolean; // 是否沒資料
    DirectPrice: Array<I_Price>; // 直客價
    IsForeign: boolean; // 是否國外團
    CurrencyCode: string; // 貨幣代碼 (ISO 4217)
}

export interface I_CostInfo {
    CostDesc: string;
    Cost: number;
}

export interface I_Meal {
    MealType: MealTypes;
    Price: number;
}

export interface I_Price {
    PriceStyle: PriceStyles;
    PriceKind: PriceKinds;
    AdultsPrice: number;
    ChildrenWithBed: number;
    ChildrenNoPrice: number;
    ChildrenExtraBed: number;
    BabyPrice: number;
}

export interface I_PriceReOrg {
    PriceStyle: PriceStyles; // 類型
    PriceKind: PriceKinds; // 價格種類(W：同業價、D：直客價、E：企業價)
    AdultsPrice: string; // 大人售價
    ChildrenWithBed: string; // 孩童佔床售價
    ChildrenNoPrice: string; // 孩童不佔床售價
    ChildrenExtraBed: string; // 孩童加床售價
    BabyPrice: string; // 嬰兒售價
    AdultsPriceOrig: string; // 大人原價
    ChildrenWithBedOrig: string; // 孩童佔床原價
    ChildrenNoPriceOrig: string; // 孩童不佔床原價
    ChildrenExtraBedOrig: string; // 孩童加床原價
    BabyPriceOrig: string; // 嬰兒原價
}

export enum PriceStyles {
    Participation = 0, // 參團費 (暫定)
    Single = 1, // 單人
    Double = 2, // 雙人
    Triple = 3, // 三人
    Quadruple = 4, // 四人
}

export enum PriceKinds {
    W, // 同業價 ( Fellow Price )
    D, // 直客價 ( Direct Price )
    E, // 企業價 ( Enterprise Price )
}

export enum MealTypes {
    Adult = 1,
    Child = 2,
}

export enum TravelTypes {
    Group = 1,
    GroupFree = 2,
}

export interface I_CostItem {
    CostDesc: string; // 費用說明標題
    Cost: string; // 費用說明內容
}

// 本日期他出發團

export interface I_TodayMoreGroup {
    GroupID: string; // 團號-團號公司
    IsEnsureGroup: boolean; // 是否為保證出團
    TotalSeats: number; // 總團位數
    QuotaSeats: number; // 可賣位數
    StraightLowestPrice: number; // 大人最低值售價
    IsVip: boolean; // 是否有會員限購價
    VipOrigPrice: number; // 會員限購價最低價
    Status: number; // 產品開發狀態： 1:報名, 2:候補, 3:額滿, 4:請洽專員, 5:關團(包含結團、鎖團、已截止), 6:近期上架
    StatusName: string; // 狀態名稱
    StatusClass: string; // 狀態等級
    ArriveTaiwanDate: string; // 抵達台灣時間
    DirectionList: Array<I_DirectionList>; // 航班資訊
    CurrencyCode: string; // 幣別
}

export interface I_DirectionList {
    id: string; // 航班方向: 1:去程, 9:回程, O:中段, X:湊票不含此段
    Name: string; // 航班方向名稱: 1:去程, 9:回程, O:中段, X:湊票不含此段
    FlightList: Array<I_FlightList>;
}

export interface I_FlightList {
    DepartureDate: string; // 出發日期
    DepartTime: string; // 出發時間
    ArriveDate: string; // 抵達日期
    ArriveTime: string; // 抵達時間
    DepartureAirport: string; // 起飛機場
    ArriveAirport: string; // 抵達機場
    Airline: string; // 航空公司
    FlightNo: string; // 航班或班次編號
    FlightTime: string; // 飛行時間
}

export interface I_GroupAllSchedules {
    GroupIDList: string; // 所有的 GropuID, 以"," 分隔
    TourIDList: I_TourIDItem[];
    AllMinGoDate: string; // 最近出發日期
    AllMaxGoDate: string; // 最遠出發日期
    CompareUrl: string; // 行程比較 url
}

export interface I_TourIDItem {
    TourID: string; // 行程代號
    AllMinGoDate: string; // 最近出發日期
    AllMaxGoDate: string; // 最遠出發日期
    TourSummaryList: I_TourSummaryItem[];
}

export interface I_TourSummaryItem {
    Year: string; // 西元年
    Month: string; // 月份
    DaySum: number; // 月有出團的總日數
    GroupSum: number; // 當月出團總團數
}

export type I_StationInfoList = {
    Place: string; // 集合地點
    MusterTime: string; // 集合時間
    Address: string; // 地址
};

export interface I_CallJson {
    BuName: string; // 聯營商品公司名稱
    Data:
        | {
              Staff: string; // 業務人員
              Phone: string; // 電話
          }[]
        | null;
}
